import { RootState, ThunkDispatch } from "core-integration/src/store";
import {
  cancelActiveChip,
  cancelProposedChip,
  proposeAvailableChip,
  restoreCancelledChip,
} from "core-integration/src/store/chips/actions";
import {
  getActiveChip,
  getActiveOrProposedAllChipName,
  getActiveOrProposedTeamChipName,
  getPotentialChips,
  teamChipsHaveChanged,
} from "core-integration/src/store/chips/reducers";
import { IPotentialChip } from "core-integration/src/store/chips/types";
import { getElementsById } from "core-integration/src/store/elements/reducers";
import { showElementSummary } from "core-integration/src/store/elements/thunks";
import {
  IElement,
  IElementsById,
} from "core-integration/src/store/elements/types";
import { getEntry } from "core-integration/src/store/entries/reducers";
import { fetchEntrySummary } from "core-integration/src/store/entries/thunks";
import { IPickLight } from "core-integration/src/store/entries/types";
import { getNextEvent } from "core-integration/src/store/events/reducers";
import { getFixturesForNextEventByTeam } from "core-integration/src/store/fixtures/reducers";
import { IFixturesForEventByTeam } from "core-integration/src/store/fixtures/types";
import { getRules } from "core-integration/src/store/game/reducers";
import { IRules } from "core-integration/src/store/game/types";
import {
  changeCaptain,
  changeViceCaptain,
} from "core-integration/src/store/my-team/actions";
import {
  getMyFormation,
  getMyPicksProposed,
  getMyTeamSavingState,
  hasMyTeamChanged,
  isMyTeamValid,
} from "core-integration/src/store/my-team/reducers";
import {
  actionSubstitution,
  fetchMyTeam,
  saveMyTeam,
} from "core-integration/src/store/my-team/thunks";
import { IPickProposed } from "core-integration/src/store/my-team/types";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import { ILoggedInPlayer } from "core-integration/src/store/player/types";
import { getProposedElements } from "core-integration/src/store/squad/reducers";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import { ITeamsById } from "core-integration/src/store/teams/types";
import {
  formatRawAsISO,
  formatRawAsLocalI18n,
} from "core-integration/src/utils/datetime";
import { range } from "lodash";
import { size } from "polished";
import { useEffect, useState } from "react";
import { Trans, WithTranslation, withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useBlocker, useNavigate } from "react-router";
import { Box } from "rebass/styled-components";
import styled, { css } from "styled-components";
import { dateLocales } from "../../i18n";
import ArrowRight from "../../img/icons/arrow-right.svg?react";
import DoubleCaptain from "../../img/icons/double-captain.svg?react";
import LoanRangers from "../../img/icons/loan-ranger.svg?react";
import ParkBus from "../../img/icons/park-the-bus.svg?react";
import { ChipName, getAllChipDetails } from "../../utils/chips";
import { isRTL } from "../../utils/locale";
import Alert from "../Alert";
import Button from "../Button";
import ButtonLink from "../ButtonLink";
import Copy from "../Copy";
import DeadlineBar from "../DeadlineBar";
import Dialog, { DialogButtonItem } from "../Dialog";
import DialogHeading from "../DialogHeading";
import DialogManager from "../DialogManager";
import EcalBanner from "../EcalBanner";
import Entry from "../Entry";
import { FixturesForElement } from "../FixtureForElement";
import Fixtures from "../Fixtures";
import { Main, Secondary, Wrapper } from "../Layout";
import Link from "../Link";
import { ElementRow } from "../Pitch";
import Title from "../Title";
import Tooltip, { TooltipLabel } from "../Tooltip";
import UnsavedChangesDialog from "../UnsavedChangesDialog";
import DreamTeam from "../icons/DreamTeam";
import SquadActionBar from "../squad/SquadActionBar";
import TabPanel from "../tabs/TabPanel";
import Tabs from "../tabs/Tabs";
import Bench from "./Bench";
import BenchUnit from "./BenchUnit";
import MyTeamTable from "./MyTeamTable";
import PitchFormation from "./PitchFormation";

const ChipLabel = styled.div`
  width: 100%;
  align-content: center;
  margin: 0 auto;
  padding: 0.6rem;
  background-color: ${({ theme }) => theme.colors.orange};
  border-radius: 4px;
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 10px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary};
  text-transform: uppercase;
  text-align: center;
`;

const ChipLabelContainer = styled.div`
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  inset-inline-start: 0;
`;

const StyledChipLinkStatus = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    flex-direction: row;
    gap: 3px;
  }
`;

const StyledPitchWrapper = styled(Box)`
  border: ${({ theme }) => theme.borders[0]};
  border-radius: ${({ theme }) => theme.radii[2]};
`;

const ChipList = styled.ul`
  display: flex;
  align-items: center;
  margin: ${({ theme }) => theme.space[4]} 0 0;
  /* padding: 10px 10px 20px; */
  padding: 0;
  list-style-type: none;
  gap: 8px;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin-bottom: 0;
    gap: 16px;
  }
`;

const ChipItem = styled.li`
  position: relative;
  flex: 1 0 0;
  padding-inline-end: ${({ theme }) => theme.space[1]};
  padding-inline-start: ${({ theme }) => theme.space[1]};
  padding-bottom: ${({ theme }) => theme.space[1]};
  border: ${({ theme }) => theme.borders[0]};
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.white4};
`;

const Chip = styled.div`
  padding-top: 2.8rem;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin: ${({ theme }) => `${theme.space[2]} 0 0`};
    padding-top: 1.6rem;
    font-size: ${({ theme }) => theme.fontSizes[4]};
  }
`;

const ChipHeading = styled.h3`
  display: inline-block;
  margin: ${({ theme }) => `${theme.space[2]} 0`};
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.impact};
  font-size: ${({ theme }) => theme.fontSizes[0]};
  font-weight: normal;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin: ${({ theme }) =>
      `${theme.space[1]} ${theme.space[0]} ${theme.space[3]}`};
    font-size: ${({ theme }) => theme.fontSizes[3]};
  }
`;

const ChipIcon = styled.div`
  svg {
    width: 60px;
    height: 60px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    svg {
      width: 73px;
      height: 73px;
    }
  }
`;

const ChipLink = styled(Link)`
  position: relative;
  display: block;
  width: 100%;
  padding: ${({ theme }) => `0.6rem ${theme.space[4]}`};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.grey};
  color: #333;
  font-size: ${({ theme }) => theme.fontSizes[0]};
  font-family: ${({ theme }) => theme.fonts.base};
  font-weight: 600;

  &:hover {
    text-decoration: none;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    padding: ${({ theme }) => `1.3rem ${theme.space[4]}`};
    font-size: 1.4rem;
  }
`;

const ChipLinkArrow = styled(ArrowRight)`
  ${size(10)};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  fill: currentColor;
  cursor: pointer;
  ${
    isRTL()
      ? css`
          left: ${({ theme }) => theme.space[2]};
          transform: translateY(-50%) scaleX(-1);
        `
      : css`
          right: ${({ theme }) => theme.space[2]};
        `
  }
`;

const renderPickValue =
  (initProps: {
    elementsById: IElementsById;
    fixturesForNextEventByTeam: IFixturesForEventByTeam;
    teamsById: ITeamsById;
  }) =>
  (pick: IPickLight) => {
    const element = initProps.elementsById[pick.element];
    return (
      <FixturesForElement
        fixtures={initProps.fixturesForNextEventByTeam[element.team]}
        element={element}
        teamsById={initProps.teamsById}
      />
    );
  };

const PlayerActions = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    margin: 0 auto;
  }
`;

const MyTeam = ({ i18n, t }: WithTranslation) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const navigate = useNavigate();
  const [pickForMenu, setPickForMenu] = useState<IPickProposed | null>(null);

  const player = useSelector(getPlayerData) as ILoggedInPlayer;
  const activeChip = useSelector(getActiveChip);
  const chipInPlayName = useSelector(getActiveOrProposedTeamChipName);
  const chipAllPlayName = useSelector(getActiveOrProposedAllChipName);
  const changed = useSelector(hasMyTeamChanged);
  const chips = useSelector(getPotentialChips);
  const chipsChanged = useSelector(teamChipsHaveChanged);
  const elementsById = useSelector(getElementsById);
  const entry = useSelector((state: RootState) =>
    getEntry(state, player.entry),
  );
  const fixturesForNextEventByTeam = useSelector(getFixturesForNextEventByTeam);
  const formation = useSelector(getMyFormation);
  const nextEvent = useSelector(getNextEvent);
  const picks = useSelector(getMyPicksProposed);
  const savingState = useSelector(getMyTeamSavingState);
  const rules = useSelector(getRules) as IRules;
  const teamsById = useSelector(getTeamsById);
  const valid = useSelector(isMyTeamValid);

  const proposedElements = useSelector(getProposedElements);
  const canSave =
    (changed || chipsChanged) && valid && savingState !== "saving";

  // useBlocker allows us to intercept navigation if a condition is met. Here we use
  // hasChanged so that if team changes have been made we ask the user to confirm
  // they are happy for changes to be lost
  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    return (
      chipsChanged ||
      (Object.keys(proposedElements).length > 0 &&
        changed &&
        currentLocation.pathname !== nextLocation.pathname)
    );
  });

  const handleShowMenuForPickElement = (element: number) => {
    const matches = picks.filter((p) => p.element === element);
    if (matches.length) {
      setPickForMenu(matches[0]);
    }
  };

  const handleHideMenuForPick = () => {
    setPickForMenu(null);
  };

  const renderDreamTeam = (pick: IPickLight) =>
    elementsById[pick.element].in_dreamteam ? (
      <Link to="/dream-team/">
        <DreamTeam />
      </Link>
    ) : null;

  const action = (
    type: "substitute" | "makeCaptain" | "makeViceCaptain",
    element: number,
  ) => {
    handleHideMenuForPick();
    switch (type) {
      case "substitute":
        dispatch(actionSubstitution(element));
        break;
      case "makeCaptain":
        dispatch(changeCaptain(element));
        break;
      case "makeViceCaptain":
        dispatch(changeViceCaptain(element));
        break;
    }
  };

  const showDialog = (element: IElement) => {
    dispatch(showElementSummary(element.id));
    handleHideMenuForPick();
  };

  const renderMenu = () => {
    const pick = pickForMenu;
    if (!pick) {
      return null;
    }
    const element = elementsById[pick.element];
    const status = pick.subStatus;
    const startMax = rules.squad_squadplay;
    return (
      <Dialog closeDialog={handleHideMenuForPick}>
        <Dialog.Header closeDialog={handleHideMenuForPick}>
          <DialogHeading>
            {`${element.first_name} ${element.second_name}`}
          </DialogHeading>
        </Dialog.Header>
        <Dialog.Body>
          <PlayerActions>
            {status.match(/^(target|)$/) && (
              <DialogButtonItem>
                <Button
                  onClick={() => action("substitute", pick.element)}
                  width={1}
                  variant="primary"
                >
                  {t("myTeam.menuDialog.switch", "Switch")}
                </Button>
              </DialogButtonItem>
            )}
            {status === "instigator" && (
              <DialogButtonItem>
                <Button
                  onClick={() => action("substitute", pick.element)}
                  width={1}
                  variant="primary"
                >
                  {t("myTeam.menuDialog.cancel", "Cancel")}
                </Button>
              </DialogButtonItem>
            )}
            {!status && pick.position <= startMax && !pick.is_captain && (
              <DialogButtonItem>
                <Button
                  onClick={() => action("makeCaptain", pick.element)}
                  width={1}
                  variant="primary"
                >
                  {t("myTeam.menuDialog.makeCaptain", "Make Captain")}
                </Button>
              </DialogButtonItem>
            )}
            {!status && pick.position <= startMax && !pick.is_vice_captain && (
              <DialogButtonItem>
                <Button
                  onClick={() => action("makeViceCaptain", pick.element)}
                  width={1}
                  variant="primary"
                >
                  {t("myTeam.menuDialog.makeViceCaptain", "Make Vice Captain")}
                </Button>
              </DialogButtonItem>
            )}
            <DialogButtonItem>
              <Button
                onClick={() => showDialog(element)}
                width={1}
                variant="primary"
              >
                {t("myTeam.menuDialog.viewInfo", "View Information")}
              </Button>
            </DialogButtonItem>
          </PlayerActions>
        </Dialog.Body>
      </Dialog>
    );
  };

  useEffect(() => {
    dispatch(fetchMyTeam());
    dispatch(fetchEntrySummary(player.entry));
  }, [dispatch, player.entry]);

  const renderChipAction = (c: IPotentialChip) => {
    switch (c.status_for_entry) {
      case "unavailable":
        return (
          <Button
            onClick={() => proposeAvailableChip(c.name)}
            disabled={Boolean(c.status_for_entry)}
            width={1}
            variant="primary"
          >
            {t("myTeam.unavailable", "Unavailable")}
          </Button>
        );
      case "available":
        return (
          <Button
            onClick={() => dispatch(proposeAvailableChip(c.name))}
            disabled={Boolean(chipInPlayName)}
            width={1}
            variant="primary"
          >
            {t("myTeam.play", "Play")}
          </Button>
        );
      case "proposed":
        return (
          <Button
            variant="secondary"
            onClick={() => dispatch(cancelProposedChip(c.name))}
            width={1}
          >
            {t("myTeam.cancel", "Cancel")}
          </Button>
        );
      case "active":
        return (
          <Button
            variant="secondary"
            onClick={() => dispatch(cancelActiveChip(c.name))}
            width={1}
          >
            {t("myTeam.cancel", "Cancel")}
          </Button>
        );
      case "cancelled":
        return (
          <Button
            variant="primary"
            onClick={() => dispatch(restoreCancelledChip(c.name))}
            disabled={Boolean(chipInPlayName)}
            width={1}
          >
            {t("myTeam.restore", "Restore")}
          </Button>
        );
      case "played":
        if (!entry) {
          return (
            <>
              <div>{t("myTeam.played", "Played")}</div>
              <div>{`${t("myTeam.round", "Round")} ${
                c.played_by_entry[0]
              }`}</div>
            </>
          );
        }
        return (
          <ChipLink to={`/entry/${entry.id}/event/${c.played_by_entry[0]}`}>
            <StyledChipLinkStatus>
              <div>{t("myTeam.played", "Played")}</div>
              <div>{`${t("myTeam.round", "Round")} ${
                c.played_by_entry[0]
              }`}</div>
              <ChipLinkArrow />
            </StyledChipLinkStatus>
          </ChipLink>
        );
      default:
        return "";
    }
  };

  const renderUnlimitChipAction = (c: IPotentialChip) => {
    switch (c.status_for_entry) {
      case "unavailable":
        return (
          <Button disabled={true} width={1}>
            {t("myTeam.unavailable", "Unavailable")}
          </Button>
        );
      case "available":
        return (
          <DialogManager
            render={(showDialog, handleShow, handleHide) => (
              <>
                <Button
                  onClick={handleShow}
                  disabled={Boolean(chipInPlayName)}
                  width={1}
                  variant="primary"
                >
                  {t("myTeam.play", "Play")}
                </Button>
                {showDialog && (
                  <Dialog closeDialog={handleHide}>
                    <Dialog.Header closeDialog={handleHide}>
                      <DialogHeading>
                        {t("myTeam.chips.unlimit.name", "Loan Rangers")}
                      </DialogHeading>
                    </Dialog.Header>
                    <Dialog.Body isPadded={true}>
                      <Copy>
                        <p>
                          {t(
                            "myTeam.chips.unlimit.dialog.p1",
                            "The Loan Rangers chip is played when confirming your transfers. You receive two Loan Rangers chips during the season.",
                          )}
                        </p>
                        <p>
                          {t(
                            "myTeam.chips.unlimit.dialog.p2",
                            "It allows you to make unlimited free transfers and select any number of players from one club for a single round. At the next deadline, your squad returns to how it was before the chip was played.",
                          )}
                        </p>
                        <p>
                          {t(
                            "myTeam.chips.unlimit.dialog.p2A",
                            "The first chip is available from the start of the season until the Round 18 deadline. The second is available from the Round 20 deadline until the end of the season. The first chip does not carry over.",
                          )}
                        </p>
                        <p>
                          <Trans i18nKey="myTeam.chips.unlimit.dialog.p3">
                            Please note: Loan Rangers{" "}
                            <strong>cannot be cancelled </strong> once
                            confirmed.
                          </Trans>
                        </p>
                        <ButtonLink
                          to="/transfers"
                          onClick={handleHide}
                          variant="primary"
                          justifyContent="center"
                        >
                          {t("myTeam.goToTransfers", "Go to Transfers")}
                        </ButtonLink>
                      </Copy>
                    </Dialog.Body>
                  </Dialog>
                )}
              </>
            )}
          />
        );
      case "active":
        return (
          <Button
            variant="secondary"
            onClick={() => navigate("/transfers")}
            width={1}
          >
            {t("myTeam.view", "View")}
          </Button>
        );
      case "played":
        if (!entry) {
          return (
            <>
              <div>{t("myTeam.active", "Active")}</div>
              <div>{`${t("myTeam.round", "Round")} ${
                c.played_by_entry[0]
              }`}</div>
            </>
          );
        }
        return (
          <ChipLink to={`/entry/${entry.id}/event/${c.played_by_entry[0]}`}>
            <StyledChipLinkStatus>
              <div>{t("myTeam.played", "Played")}</div>
              <div>{`${t("myTeam.round", "Round")} ${
                c.played_by_entry[0]
              }`}</div>
              <ChipLinkArrow />
            </StyledChipLinkStatus>
          </ChipLink>
        );
      default:
        return "";
    }
  };

  if (!entry || !picks.length) {
    return null;
  }
  // Create a new function on each render as fixtures could have changed and
  // need to ensure a render of connected subcomponents
  const _renderPickValue = renderPickValue({
    elementsById,
    teamsById,
    fixturesForNextEventByTeam,
  });
  const benchHeading: Record<string, React.ReactNode> = {
    11: (
      <Tooltip content="Goalkeeper">
        <TooltipLabel>GK</TooltipLabel>
      </Tooltip>
    ),
    12: "1",
    13: "2",
    14: "3",
  };

  const unlimitChip = chips.filter((c) => c.name === "uteam")[0];
  const chipDetails = getAllChipDetails(t);

  const getChipIcon = (chipName: string) => {
    switch (chipName) {
      case "2capt":
        return <DoubleCaptain />;
      case "pdbus":
        return <ParkBus />;
      case "uteam":
        return <LoanRangers />;
      default:
        return null;
    }
  };

  return (
    <>
      <Wrapper>
        <Main>
          <Box mx={2} mb={4}>
            <Title>{t("myTeam.title", "My Team")}</Title>
          </Box>
          {blocker.state === "blocked" && (
            <UnsavedChangesDialog
              handleConfirm={() =>
                blocker.state === "blocked" && blocker.proceed()
              }
              handleHide={() => blocker.state === "blocked" && blocker.reset()}
            />
          )}
          {nextEvent && (
            <DeadlineBar
              deadlineISO={formatRawAsISO(nextEvent.deadline_time)}
              deadlineLocal={formatRawAsLocalI18n(
                nextEvent.deadline_time,
                dateLocales[i18n.language],
              )}
              headingText={nextEvent.name}
            />
          )}
          <Box my={2}>
            <Alert type="info">
              {t(
                "myTeam.alerts.captain",
                "To change your captain use the menu which appears when clicking on a player's shirt.",
              )}
            </Alert>
          </Box>
          {activeChip && activeChip.name === "wildcard" && (
            <Box my={2}>
              <Alert type="info">
                <p>
                  {t("myTeam.alerts.transferChip", "{{ chipName }} Active", {
                    chipName: chipDetails[activeChip.name as ChipName].name,
                  })}
                </p>
              </Alert>
            </Box>
          )}
          <ChipList>
            {chips
              .filter((c) => ["2capt", "pdbus"].indexOf(c.name) > -1)
              .map((c) => (
                <ChipItem key={c.name}>
                  <ChipLabelContainer>
                    {(c.status_for_entry === "active" ||
                      c.status_for_entry === "proposed") && (
                      <ChipLabel>
                        {t("entryEvent.ChipStatus.active", "Active")}
                      </ChipLabel>
                    )}
                  </ChipLabelContainer>
                  <Chip>
                    <ChipIcon>{getChipIcon(c.name)}</ChipIcon>
                    <Tooltip
                      content={chipDetails[c.name as ChipName].description}
                    >
                      <ChipHeading>
                        {chipDetails[c.name as ChipName].name}
                      </ChipHeading>
                    </Tooltip>
                    {renderChipAction(c)}
                  </Chip>
                </ChipItem>
              ))}
            {unlimitChip && (
              <ChipItem>
                <ChipLabelContainer>
                  {unlimitChip.status_for_entry === "active" ||
                  unlimitChip.status_for_entry === "proposed" ? (
                    <ChipLabel>
                      {t("entryEvent.ChipStatus.active", "Active")}
                    </ChipLabel>
                  ) : (
                    <></>
                  )}
                </ChipLabelContainer>
                <Chip>
                  <ChipIcon>{getChipIcon(unlimitChip.name)}</ChipIcon>
                  <Tooltip
                    content={
                      chipDetails[unlimitChip.name as ChipName].description
                    }
                  >
                    <ChipHeading>
                      {chipDetails[unlimitChip.name as ChipName].name}
                    </ChipHeading>
                  </Tooltip>
                  {renderUnlimitChipAction(unlimitChip)}
                </Chip>
              </ChipItem>
            )}
          </ChipList>
          <EcalBanner />
          {savingState === "saved" && (
            <Box my={4}>
              <Alert type="success">
                {t("myTeam.alerts.teamSaved", "Your team has been saved.")}
              </Alert>
            </Box>
          )}
          <Box mb={6}>
            <StyledPitchWrapper pt={4}>
              <Box mx={2} mb={2}>
                <Tabs centered>
                  <TabPanel
                    label={t("myTeam.pitchView", "Pitch View")}
                    link="pitch"
                  >
                    <Box mx={-2} pt={4}>
                      <PitchFormation
                        chipName={chipAllPlayName}
                        formation={formation}
                        picks={picks}
                        renderDreamTeam={renderDreamTeam}
                        renderElementMenu={handleShowMenuForPickElement}
                        renderPickValue={_renderPickValue}
                      />
                      <Bench>
                        <ElementRow>
                          {range(
                            rules.squad_squadplay,
                            rules.squad_squadsize,
                          ).map((i) => (
                            <BenchUnit
                              key={i}
                              chipName={chipAllPlayName}
                              heading={benchHeading[i]}
                              pick={picks[i]}
                              renderElementMenu={() =>
                                handleShowMenuForPickElement(picks[i].element)
                              }
                              renderDreamTeam={renderDreamTeam}
                              renderPickValue={_renderPickValue}
                            />
                          ))}
                        </ElementRow>
                      </Bench>
                    </Box>
                  </TabPanel>
                  <TabPanel
                    label={t("myTeam.listView", "List View")}
                    link="list"
                  >
                    <Box mt={4} mb={4} mx="-1px">
                      <MyTeamTable
                        title={t("myTeam.starters", "Starters")}
                        picks={picks.slice(0, rules.squad_squadplay)}
                        renderElementMenu={handleShowMenuForPickElement}
                      />
                      <MyTeamTable
                        title={t("myTeam.substitutes", "Substitutes")}
                        picks={picks.slice(rules.squad_squadplay)}
                        renderElementMenu={handleShowMenuForPickElement}
                      />
                    </Box>
                  </TabPanel>
                </Tabs>
              </Box>
            </StyledPitchWrapper>
            <SquadActionBar>
              <Button
                variant="primary"
                onClick={() => dispatch(saveMyTeam())}
                disabled={!canSave}
                width={1}
              >
                {t("myTeam.saveTeam", "Save Your Team")}
              </Button>
            </SquadActionBar>
            {renderMenu()}
          </Box>
          <Fixtures />
        </Main>
        <Secondary>
          <Entry entryId={entry.id} />
        </Secondary>
      </Wrapper>
    </>
  );
};

export default withTranslation()(MyTeam);
